module.exports = __webpack_public_path__ + "static/media/Tag-icon.294ceef1.svg";